import { observer } from 'mobx-react-lite';
import React from 'react';

import DeleteConfirmationModal from 'common/DeleteConfirmationModal';
import { groupsStore } from 'pages/Profile/GroupsStore';

import { DELETE_GROUP_CONFIRMATION_MODAL_TEXT } from './text';

const DeleteGroupConfirmationModal = observer(() => {
	const { isInDelete, isDeleting } = groupsStore;

	return (
		<DeleteConfirmationModal
			active={isInDelete}
			itemLabel={DELETE_GROUP_CONFIRMATION_MODAL_TEXT.itemLabel}
			extraLabel={DELETE_GROUP_CONFIRMATION_MODAL_TEXT.extraLabel}
			loading={isDeleting}
			onCancel={groupsStore.resetDeleteMode}
			onConfirm={groupsStore.deleteGroup}
			title={DELETE_GROUP_CONFIRMATION_MODAL_TEXT.title}
		/>
	);
});

export default DeleteGroupConfirmationModal;
